export default __webpack_public_path__ + "static/media/9.063a4b5c.png";